const getters = {
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  loadRouter: state => state.permission.loadRouter,
  pathAccess: state => state.permission.pathAccess,
  subjectData: state => state.permission.subjectData
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js